import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DATA_SOURCES, DataSourceConnector } from '../datasources/datasources.data';
import { RappiderCardWithIconTitleDescriptionListComponent, CardIconTitleDescription } from '@rappider/rappider-components';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ConnectFileExplorer } from 'libs/file-explorer/src/lib/state/file-explorer.actions';
import { BrowserStorageManagementService } from '@rappider/services';
import { ProvidersType } from '../../utils/providers.enums';
import { FullPaths } from '@rappider/shared/definitions';

@Component({
  selector: 'rappider-datasource-new-options',
  standalone: true,
  imports: [
    CommonModule,
    RappiderCardWithIconTitleDescriptionListComponent
  ],
  templateUrl: './datasource-new-options.component.html',
  styleUrls: ['./datasource-new-options.component.scss'],
})
export class RappiderDatasourceNewOptionsComponent {

  datasourceCreateOptions = DATA_SOURCES;

  constructor(private router: Router, private browserStorageManagementService: BrowserStorageManagementService, private store: Store<any>) { }

  onEntityItemSelectedForAddingDatasource(item: { id: string; title: string; key?: string; optional?: any }) {
    if (item?.key === 'contact-us-datasource') {
      const zendeskButton = document.getElementById('customZendeskButton');
      if (zendeskButton) {
        zendeskButton.click();
      }
      return;
    }
    if (item?.key && item?.key === DataSourceConnector.GoogleDrive || item?.key && item?.key === DataSourceConnector.MicrosoftOneDrive || item?.key && item?.key === DataSourceConnector.AmazonS3) {
      this.store.dispatch(ConnectFileExplorer({ payload: { provider: item?.key === DataSourceConnector.GoogleDrive ? ProvidersType.Google : item?.key === DataSourceConnector.MicrosoftOneDrive ? ProvidersType.Microsoft : ProvidersType.AmazonS3 } }))
      this.router.navigate([FullPaths.AIDataSourcesFileExplorerConnect]);
    } else if (item?.key && item?.key === DataSourceConnector.Salesforce) {
      this.router.navigate([FullPaths.AIDataSourcesSalesforceConnect]);
    } else {
      this.router.navigate([FullPaths.AIDataSourcesCreate, item?.key]);
    }

    if (item.optional === 'sixth' && (this.browserStorageManagementService.getLocalStorageItem('tour') !== 'nineth')) {
      this.browserStorageManagementService.setLocalStorageItem('tour', 'seventh');
    }
  }

  onJoyrideDoneButtonClick() {
    this.browserStorageManagementService.setLocalStorageItem('tour', 'stop');
  }
}
